import React from 'react';
import CloseIconSVG from 'src/client/components/common/SnackBar/closeIcon.svg';

type Props = { onClick: () => void };

export const CloseIcon = ({ onClick }: Props) => {
  return (
    <>
      <div onClick={onClick}>
        <CloseIconSVG className="close-icon" />
        <style jsx>{`
          .close-icon {
            position: absolute;
            top: 14px;
            right: 13px;
          }
        `}</style>
      </div>
    </>
  );
};
